<template>
  <b-modal
    @show="onShow"
    :visible="visible"
    centered
    hide-header
    dialog-class="modal-dialog2"
    contentClass="md-confirm-content p-4"
    bodyClass= "confirm-body"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    @ok="onConfirm"
    @hidden="onCancel"
  >
    <div class="full container" style="padding-top: 10px;">
      <div class="align-vertical pb-2">
        <div class="width_100 h_center pb-4">
          <div class="align-vertical">
            <span class="page_title">{{site_name}}</span>
            <div class="align-horizontal h_center mt-1" v-if="address">
              <b-img class="ml-1 mr-1" :src="require('../../../assets/image/ic_address_detail@2x.png')" style="height: 20px; vertical-align: text-bottom;" />
              <span class="address_text">{{address}}</span>
            </div>
          </div>
        </div>
        <div class="align-vertical" v-if="groupList && groupList.length > 0">
          <div class="align-vertical" style="align-items: center;">
            <b-dropdown :no-caret=true variant="none" style="width: 90%; height:40px;"
                        :toggle-class="['grp_btn' ,selectedGroup!=null ?'grp_active':'border']"
                        menu-class="width_100"
                        :text="$t('group.select_group_title')">
              <b-dropdown-item  v-for = "(group, i) in groupList" :key="i" @click="onSelectGroup(i)" style="width: 100%; height:40px; font-size: 18px; font-family: 'KoreanGD14R';"
                               :link-class="['grp_btn' ,groupName == group.f_name ?'grp_active':'']"
              >
                {{group.f_name}}
              </b-dropdown-item>
              <template #button-content>
                <div class="align-horizontal width_100" style="padding: 0 0.2em 0 0.2em; position: relative; font-size: 18px; font-family: 'KoreanGD14R';">
                  <span class="flex_1">{{groupName}}</span>
                  <b-icon v-if="selectedGroup == null" icon="chevron-down" font-scale="0.8" style="position: absolute; right: 0;" />
                </div>
              </template>
            </b-dropdown>
          </div>
          <div class="width_100 h_center mt-4">
            <span class="titleLabel">{{$t('group.share_maemul_to_group')}}</span>
          </div>
          <div class="width_100 h_center mt-4">
            <span class="contentLabel">{{$t('group.group_member_can')}}</span>
          </div>
        </div>
        <div v-else class="align-vertical center">
          <div class="select_wrapper" style="border-color: #cf0000; width: 75%">
            <span class="btnLabel no_group_affiliated_label">{{$t('group.no_group_involved')}}</span>
          </div>
          <div class="width_100 h_center mt-4">
            <span class="titleLabel" style="line-height: 25px">
              {{$t('group.create_or_invited_group')}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
export default {
  name: "SelectGroupPopup",
  components: {},
  data() {
    return {
      self: this,
      u: Utils,
      visible: false,
      selectedGroup: null,
      groupList: [],
      onConfirm: () => {},
      site_name: '',
      address: '',
      showDropDownList: false,
      groupName:this.$t('group.select_group_title'),
    }
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  methods: {
    onSelectGroup(i) {
      this.groupName = this.groupList[i].f_name;
      this.selectedGroup = this.groupList[i];
    },
    onShow() {
      Utils.requestGet(this.$c.API.Group.getMyGroupList, {}).then(result => {
        if(result.code == this.$c.API_RES_CODE.SUCCESS)
        {
          Utils.setState(this,{selectedGroup: null,groupList: result.data})
        } else
          Utils.toast(this, result.msg);
      })
    },
    onCancel() {
      this.selectedGroup = null;
      this.groupName = this.$t('group.select_group_title');
      this.visible = false;
    },
    show (site_name, address, onConfirm) {
      Utils.setState(this,{
        site_name: site_name,
        address: address,
        onConfirm: () => {
          if (this.selectedGroup)
            Utils.setState(this,{visible: false}, () => onConfirm(this.selectedGroup));
          else {
            if (this.groupList && this.groupList.length > 0)
             Utils.toast(this, this.$t('group.select_group_title'));
            else
              Utils.setState(this,{visible: false}, () => onConfirm(null, true));
          }
        },
        visible: true,
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";
.page_title {
  text-align: center ;
  color:  $black ;
  font-size:  $fs_22 ;
  font-family:  $korean_gd_15_r ;

 }
.address_text {
  color: #0660e2 ;
  font-size:  $fs_18 ;
  font-family:  $korean_gd_14_r ;
  margin-left: 6px ;

 }
.titleLabel {
  font-size:  $fs_20 ;
  color:  $black ;
  text-align: center ;
  // line-height: 25 ;
  font-family:  $korean_gd_15_r ;
 }
.contentLabel {
  font-size:  $fs_20 ;
  color:  $trading1 ;
  text-align: center ;
  // line-height: 27 ;
  font-family:  $korean_gd_15_r ;
  text-decoration-line: underline ;
 }
.control {align-self: center ; margin-top: 25px }
.btn {width: 88px ; height: 37px ; border-radius: 3px ; justify-content: center ; align-items: center }
.btnLabel {color:  $white ; font-size:  $fs_16 ; font-family:  $korean_gd_15_r ;  }
.no_group_affiliated_label {color:  $trading ; font-size:  $fs_20 ; font-family:  $korean_gd_14_r }

.select_wrapper {
  display: flex;
  border:solid 1px #bebdbd;
  padding-left: 15px ;
  padding-right: 15px ;
  height: 45px ;
  align-items: center ;
  justify-content: center ;
 }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SelectGroupPopup.vue